import React, { Component } from 'react';
import classNames from 'classnames';
import Button from '../Button/Button';
import RunningBulletsAnim from '../RunningBulletsAnim/RunningBulletsAnim';
import { ProcessState } from '../../store/appMode';
import WithTransition from '../../hoc/WithTransition';

class ProcessButton extends Component {
	render() {
		const mainClasses = classNames({
			[this.props.className]: this.props.className,
			[`${this.props.classBEMRoot}--${this.props.processState.toLowerCase()}`]: this.props.processState !== ProcessState.IDLE,
		});

		let renderedText = (this.props.inTransition) ? this.lastText : this.props.text;
		switch (this.props.processState) {
			case ProcessState.PROCESSED: renderedText = this.props.processedText; break;
			case ProcessState.ERROR: renderedText = this.props.errorText; break;
		}

		return (
			<Button
				classBEMRoot={this.props.classBEMRoot}
				className={mainClasses}
				active={this.props.active}
				onClick={this.props.onClick}
				addSpanForText={this.props.addSpanForText}
				text={renderedText}
				title={this.props.title ?? renderedText}
				inTransition={this.props.inTransition}
			>
				<RunningBulletsAnim
					clockPeriodMs={this.props.animClockPeriodMs ? this.props.animClockPeriodMs : 100}
					classBEMRoot={this.props.animClassBEMRoot
						? this.props.animClassBEMRoot
						: `${this.props.classBEMRoot}__dpit-anim-rb-builder`
					}
					className={this.props.animClassName}
					count={this.props.animCount ? this.props.animCount : 10}
					active={this.props.processState === ProcessState.PROCESSING}
				/>
			</Button>

		);
	}
}

export default WithTransition(ProcessButton);
